import type { ReactNode } from 'react';

// Wrap the first case-insensitive match of `q` inside `text` in a <mark>, for the
// rail search rows. Shared by every master-detail modal.
export function hl(text: string, q: string): ReactNode {
  if (!q) return text;
  const i = text.toLowerCase().indexOf(q.toLowerCase());
  if (i < 0) return text;
  return <>{text.slice(0, i)}<mark>{text.slice(i, i + q.length)}</mark>{text.slice(i + q.length)}</>;
}
